/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import styled from 'styled-components';
import { Button } from '@carbon/react';

export const ChatboxForm = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  background-color: #f4f4f4;
  border: 1px solid #8d8d8d;
  width: calc(100% - 32px);
  margin-bottom: var(--cds-spacing-05);
`;

// This wrapper is used to properly position the Carbon button. Button itself cannot be directly styled, because Carbon uses a wrapper around it.
export const ButtonWrapper = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
`;

/**
 * @type {import('styled-components').IStyledComponent<'web', {
 *     $height: number,
 *     $padding: number,
 *     value: string,
 *     placeholder: string
 * } & React.HTMLAttributes<HTMLTextAreaElement> & React.RefAttributes<HTMLTextAreaElement>>}
 */
export const StyledTextArea = styled.textarea`
  background: #f4f4f4;
  border: none;
  padding: ${({ $padding }) => '' + $padding + 'px' || '10px'};
  width: 100%;
  resize: none;
  overflow-y: scroll;
  min-height: ${({ $height }) => '' + $height + 'px' || '68px'};
  max-height: ${({ $height }) => '' + $height + 'px' || '68px'};
  line-height: 24px;
  margin-right: var(--cds-spacing-08);
`;

export const ChatboxSend = styled(Button)`
  align-self: flex-end;
`;
